// import PropTypes from "prop-types";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class CitiesComparisonChart extends ChartkickChart {
}

CitiesComparisonChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {

});

export default CitiesComparisonChart;
